import * as React from 'react';

import { useRouter } from 'next/router';

import { useAuth0 } from '@auth0/auth0-react';

import { getRoutingPath, ROUTES } from '@itp/talent/constants/routingPath';
import { useLocalAuth } from '@itp/talent/context/localAuthContext';
import { handleRouteChange } from '@itp/talent/utils/handleRouteChange';

export function useAuthRedirectGuard() {
  const { isAuthenticated: isAuth0Authenticated, isLoading } = useAuth0();
  const { isAuthenticated: isLocalAuthenticated } = useLocalAuth();
  const router = useRouter();

  const isAuthenticated = isAuth0Authenticated || isLocalAuthenticated;
  const isPageReady = !isLoading && !isAuthenticated;

  React.useEffect(() => {
    const shouldRedirect = isAuthenticated && !isLoading;
    if (shouldRedirect) {
      handleRouteChange({ toHref: getRoutingPath(ROUTES.TALENT_DASHBOARD) }, router?.push);
    }
  }, [router, isAuthenticated, isLoading]);

  return { isPageReady };
}
